import { z as zod } from 'zod';
import { DetailSchema, RelatedInfoSchema, ShowroomSchema } from "@/app/features/shared/types/schema";

export const SiteCollectionSchema = zod.object({
    details: zod.array(DetailSchema),
    showroom: ShowroomSchema,
    relatedInfos: zod.array(RelatedInfoSchema),
});